export default __webpack_public_path__ + "static/media/Sirao-Flower-Garden.81670199.jpg";